<template>
	<div id="containt">
		<el-tabs v-model="activeName" class="tab-box">
			<el-tab-pane label="常规" name="first">
				<editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self" @reload="$reloadHandle"></editView>
			</el-tab-pane>
			<el-tab-pane label="列表" name="second">
				<div class="grid-height">
					<vxe-grid ref="table-m1" v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
						<template #form>
							<div class="clearfix screen-btns">
								<div class="fl">
									<vxe-button status="primary" class="button-sty" icon="el-icon-plus" @click="openEditDialog">新增</vxe-button>
								</div>
								<div class="fr">
									<vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary" plain>重置</vxe-button>
									<vxe-button status="warning" icon="el-icon-search" class="button-sty" @click="searchEvent">搜索</vxe-button>
								</div>
							</div>
							<vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData" @submit="searchEvent" @reset="searchEvent">
								<vxe-form-item title="标题:" field="title">
									<template v-slot>
										<el-input v-model="formData.title" size="small" clearable />
									</template>
								</vxe-form-item>
							</vxe-form>
						</template>
					</vxe-grid>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import editView from './edit.vue';
export default {
	name: 'system_notice:list',
	components: {
		editView
	},
	created() {},
	mounted() {
		this.initTableList();
	},
	data() {
		return {
			activeName: 'second',
			dataId: 0,
			showEdit: false,
			vxeOption: {},
			formData: {}
		};
	},
	methods: {
		searchEvent() {
			this.$refs['table-m1'].commitProxy('reload');
		},
		resetEvent() {
			this.formData = {};
			this.$refs['table-m1'].commitProxy('reload');
		},
		openEditDialog(id) {
			this.dataId = !id || typeof id == 'object' ? 0 : id;
			this.activeName = 'first';
			this.$openEditView('showEdit');
		},
		initTableList() {
			let tableOption = {
				vue: this,
				tableRef: 'table-m1',
				tableName: 'basic_system_notice_list-m1',
				path: USER_PREFIX + '/system_notice/listPage',
				param: () => {
					return this.formData;
				},
				config: {
					pagerConfig: {
						autoHidden: false
					}
				},
				columns: [
					{ type: 'checkbox', width: 48, resizable: false, fixed: 'left' },
					{
						title: '标题',
						field: 'title',
						width: 150,
						sortable: true,
						fixed: 'left'
					},
					{
						field: 'secondTitle',
						title: '副标题',
						width: 250
					},
					{
						title: '语言',
						field: 'languageName',
						width: 150
					},
					{
						field: 'publish',
						title: '是否发布',
						width: 150,
						sortable: true,
						slots: {
							default: ({ row }) => {
								if (row.publish) {
									return [<div class="txt-status"> 发布 </div>];
								} else {
									return [<div class="txt-status s-3"> 未发布 </div>];
								}
							}
						}
					},
					{
						field: 'createDate',
						title: '创建时间',
						width: 200,
						sortable: true
					},
					{
						width: 47,
						fixed: 'right',
						title: '',
						sortable: false,
						slots: {
							default: ({ row }) => {
								return [
									<a
										href="javascript:void(0);"
										class="a-link"
										onclick={() => {
											this.openEditDialog(row.id);
										}}
									>
										<el-tooltip enterable={false} effect="dark" content="查看" placement="top" popper-class="tooltip-skin">
											<i class="el-icon-edit" />
										</el-tooltip>
									</a>
								];
							}
						}
					}
				]
			};
			this.$vxeTableUtil.initVxeTable(tableOption).then(opts => {
				this.vxeOption = opts;
			});
		}
	}
};
</script>

<style>
.sortable-column-demo .vxe-header--row .vxe-header--column.sortable-ghost,
.sortable-column-demo .vxe-header--row .vxe-header--column.sortable-chosen {
	background-color: #dfecfb;
}

.sortable-column-demo .vxe-header--row .vxe-header--column.col--fixed {
	cursor: no-drop;
}
</style>
